<template>
    <div class="register-wrap" :style="`background:url(${themeImgs.loginRegBgImg})`">
        <div class="logo-box">
            <van-image :src="require('@siteResources/logo/loginReg_logo.png')" />
        </div>
        <div class="register-out-box">
            <div class="register-box" v-if="showUsernameReg">
                <van-field
                    v-model="regParams.username"
                    :formatter="formatter"
                    clearable
                    center
                    autocomplete="off"
                    :left-icon="themeImgs.loginRegUserIcon"
                    placeholder="请输入账号"
                />
                <van-field
                    v-model="regParams.password"
                    :formatter="formatter"
                    type="password"
                    clearable
                    center
                    autocomplete="off"
                    placeholder="请输入密码"
                    :left-icon="themeImgs.loginRegKeyIcon"
                />
                <van-field
                    v-model="regParams.confirm_password"
                    :formatter="formatter"
                    type="password"
                    clearable
                    center
                    autocomplete="off"
                    placeholder="请再次输入密码"
                    :left-icon="themeImgs.loginRegKeyIcon"
                />
                <van-field
                    v-model="regParams.pay_password"
                    maxlength="6"
                    type="password"
                    :formatter="formatter"
                    clearable
                    center
                    autocomplete="off"
                    placeholder="请设置6位纯数字支付密码"
                    :left-icon="themeImgs.loginRegLockIcon"
                />
                <van-field
                    v-if="codeType==1"
                    v-model="regParams.code"
                    maxlength="4"
                    :formatter="formatter"
                    center
                    autocomplete="off"
                    placeholder="请输入验证码"
                >
                    <template #extra>
                        <van-image class="code-img" :src="graphicCodeImg" @click="handleGetGraphicCode" />
                    </template>
                </van-field>
                <Geet ref="regGeetRef" v-show="codeType==3" @handleUpdateGeetStatus="handleUpdateGeetStatus" @handleGetGeetSession="handleGetGeetSession" />
            </div>
            <div v-if="!showUsernameReg">
                <div class="register-box" v-if="!showRegPage">
                    <van-field
                        v-model="SMSCodeParams.username"
                        :formatter="formatter"
                        clearable
                        center
                        autocomplete="off"
                        placeholder="请输入手机号码"
                        :left-icon="themeImgs.loginRegPhoneIcon"
                    />
                    <van-field
                        v-if="codeType==1"
                        v-model="SMSCodeParams.code"
                        maxlength="4"
                        :formatter="formatter"
                        center
                        autocomplete="off"
                        placeholder="请输入验证码"
                    >
                        <template #extra>
                            <van-image class="code-img" :src="graphicCodeImg" @click="handleGetGraphicCode" />
                        </template>
                    </van-field>
                    <Geet ref="regGeetRef" v-show="codeType==3" @handleUpdateGeetStatus="handleUpdateGeetStatus" @handleGetGeetSession="handleGetGeetSession" />
                </div>
                <div class="register-box" v-if="showRegPage">
                    <van-field
                        v-model="regParams.username"
                        center
                        readonly
                        autocomplete="off"
                        :left-icon="themeImgs.loginRegPhoneIcon"
                    />
                    <van-field
                        v-model="regParams.code"
                        type="number"
                        maxlength="6"
                        :formatter="formatter"
                        clearable
                        center
                        autocomplete="off"
                        placeholder="请输入短信"
                        :left-icon="themeImgs.loginRegKeyIcon"
                    />
                    <van-field
                        v-model="regParams.password"
                        :formatter="formatter"
                        type="password"
                        clearable
                        center
                        autocomplete="off"
                        placeholder="请输入密码"
                        :left-icon="themeImgs.loginRegKeyIcon"
                    />
                    <van-field
                        v-model="regParams.confirm_password"
                        :formatter="formatter"
                        type="password"
                        clearable
                        center
                        autocomplete="off"
                        placeholder="请再次输入密码"
                        :left-icon="themeImgs.loginRegKeyIcon"
                    />
                    <van-field
                        v-model="regParams.pay_password"
                        maxlength="6"
                        type="password"
                        :formatter="formatter"
                        clearable
                        center
                        autocomplete="off"
                        placeholder="请设置6位纯数字支付密码"
                        :left-icon="themeImgs.loginRegLockIcon"
                    />
                </div>
            </div>
        </div>
        <div class="bottom-box" v-if="showUsernameReg">
            <div class="register-btn-box" @click="handleRegister">注册</div>
            <div class="login-box">
                已有账号，先去
                <router-link to="/login">登录</router-link>
            </div>
        </div>
        <div class="bottom-box" v-if="!showUsernameReg">
            <div class="register-btn-box" @click="handleClickSMSCodeBtn" v-if="!showRegPage">获得短信</div>
            <div class="register-btn-box" @click="handleRegister" v-if="showRegPage">注册</div>
            <div class="login-box">
                已有账号，先去
                <router-link to="/login">登录</router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, ref, reactive, onBeforeMount, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { Icon, Toast } from "vant";
import { getVerification, getGraphicCode, doRegister,getCodeType, getLoginRegSys } from "@/api/api";
import wsConnection from "@/utils/websocket"
import Geet from "@/components/Geet"

export default defineComponent({
    components: {
        [Icon.name]: Icon,
        Geet
    },
    setup() {
        const $router = useRouter();
        const store = useStore();
        const regGeetRef = ref()
        // 默认行为验证码状态
        const geetStatus = ref(1)
        // 改变行为验证码状态
        const handleUpdateGeetStatus = val => {
            geetStatus.value = val
        }
        // 存储验证码方式
        const codeType = ref('')
        // 获取验证码方式
        const handleGetCodeType = () => {
            getCodeType().then(res => {
                if(res.result == 200000) {
                    codeType.value = res.data.type
                    if(res.data.type==1) {
                        handleGetGraphicCode()
                    } else {
                        regGeetRef.value.init(res.data)
                        SMSCodeParams.session = res.data.session_id
                        regParams.session = res.data.session_id
                    }
                }
            })
        }
        // 获取极验证session
        const handleGetGeetSession = () => {
            handleGetCodeType()
        }
        // 存储图形验证码
        const graphicCodeImg = ref('')
        // 获取图形验证码
        const handleGetGraphicCode = () => {
            getGraphicCode().then(res => {
                if(res.result == 200000) {
                    graphicCodeImg.value = res.data.captcha
                    SMSCodeParams.session = res.data.session
                    regParams.session = res.data.session
                }
            })
        }
        // 获取登录验证配置
        const handleGetLoginRegSys = () => {
            getLoginRegSys().then(res => {
                if(res.result == 200000) {
                    if (res.data.info.register == 1) {
                        showUsernameReg.value = false
                    } else {
                        showUsernameReg.value = true
                    }
                    handleGetCodeType()
                }
            })
        }
        onBeforeMount(()=> {
            // handleGetCodeType()
            handleGetLoginRegSys()
        })
        // 过滤输入的中文
        const formatter = (value) => value.replace(/[\u4e00-\u9fa5]/g, "");
        const inputType = ref("password");
        const showEye = ref(true);
        const SMSCodeParams = reactive({
            username: "", // 用户名
            code: "", // 图形验证码密码
            session: ""
        });
        const regParams = reactive({
            username: "", // 用户名
            password: "", // 密码
            confirm_password: "", // 确认密码
            pay_password: "", // 支付密码
            code: "", // 短信/邮箱验证码
            session: '',
            is_captcha: 1
        });
        // 显示密码
        const changePassWordType = () => {
            showEye.value = !showEye.value;
            if (showEye.value) {
                inputType.value = "password";
            } else {
                inputType.value = "text";
            }
        };
        // 点击按钮获取短信验证码
        const handleClickSMSCodeBtn = () => {
            if (!SMSCodeParams.username) {
                return Toast.fail("请输入手机号码");
            } else if (codeType.value==1 && !SMSCodeParams.code) {
                return Toast.fail("请输入验证码");
            } else if (codeType.value==3 && geetStatus.value!=4) {
                return Toast.fail("请点击进行验证");
            } else {
                handleGetSMSCode()
            }
        }
        // 获取短信验证码
        const handleGetSMSCode = () => {
            Toast.loading({
                message: '发送中...',
                forbidClick: true,
            });
            getVerification(SMSCodeParams).then(res => {
                Toast.clear()
                if(res.result == 200000) {
                    Toast.success("发送成功");
                    showRegPage.value = true
                    regParams.username = SMSCodeParams.username
                } else {
                    if(codeType.value==3) {
                        regGeetRef.value.init()
                    } else {
                        handleGetGraphicCode()
                    }
                    Toast.fail(res.msg);
                }
            })
        }
        // 显示第二注册页
        const showRegPage = ref(false)
        // 点击注册
        const handleRegister = () => {
            if (!regParams.username) {
                return Toast.fail("请输入用户名");
            } else if (!regParams.code && !showUsernameReg.value) {
                return Toast.fail("请输入短信");
            } else if (!regParams.password) {
                return Toast.fail("请输入密码");
            } else if (!regParams.confirm_password) {
                return Toast.fail("请再次确认密码");
            } else if (regParams.password != regParams.confirm_password) {
                return Toast.fail("两次密码不一致");
            } else if (!regParams.pay_password) {
                return Toast.fail("请设置支付密码");
            }  else if (codeType.value==1 && !regParams.code && showUsernameReg.value) {
                return Toast.fail("请输入验证码");
            } else if (codeType.value==3 && geetStatus.value!=4 && showUsernameReg.value) {
                return Toast.fail("请点击进行验证");
            } else {
                doRegister(regParams).then((res) => {
                    if (res.result == 200000) {
                        Toast.success("注册成功");
                        store.dispatch("saveLoginInfosActions", res.data);
                        $router.push("/home");
                        wsConnection.initWebSocket()
                    } else {
                        if (showUsernameReg.value) {
                            if(codeType.value==3) {
                                handleGetCodeType()
                            } else {
                                handleGetGraphicCode()
                            }
                        }
                        Toast.fail(res.msg)
                    }
                });
            }
        }
        // 是否显示用户名或手机号/邮箱注册结构
        const showUsernameReg = ref(true)
        // 点击切换注册类型
        const handleChangeRegType = () => {
            showUsernameReg.value = !showUsernameReg.value
            regParams.username = ""
            regParams.password = ""
            regParams.confirm_password = ""
            regParams.pay_password = ""
            regParams.code = ""
            regParams.session = ""
        }
        // mapstate--皮肤对应的图片
        const themeImgs = computed(() => store.state.themeImgs)
        return {
            graphicCodeImg,
            handleGetGraphicCode,
            formatter,
            inputType,
            showEye,
            SMSCodeParams,
            regParams,
            changePassWordType,
            showRegPage,
            handleClickSMSCodeBtn,
            handleRegister,
            codeType,
            geetStatus,
            handleUpdateGeetStatus,
            regGeetRef,
            handleGetGeetSession,
            showUsernameReg,
            handleChangeRegType,
            themeImgs
        };
    },
});
</script>

<style lang="less" scoped>
.register-wrap {
    min-height: 100vh;
    padding: 0 25px;
    background-repeat: no-repeat !important;
    background-size: 100% 100% !important;
    .logo-box {
        position: relative;
        text-align: center;
        .van-image {
            width: 168px;
            margin-top: 38px;
        }
    }
    .register-out-box {
        padding: 30px 15px;
        background: var(--outBoxBgColor);
        box-shadow: var(--outBoxShadow);
        border-radius: 30px;
        .register-box {
            :deep(.van-cell) {
                margin-bottom: 8px;
                padding-left: 5px;
                background: inherit;
                border-bottom: 1px solid rgba(255, 255, 255, 0.2);
                .van-field__control {
                    color: var(--logRegInputTextColor);
                }
                :deep(.van-field__left-icon) {
                    width: 24px;
                    height: 24px;
                    .van-icon__image {
                        width: 24px;
                        height: 24px;
                    }
                }
                :deep(.code-img) {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 100px;
                    height: 45px;
                }
                &::after {
                    border: none;
                }
                input::-webkit-input-placeholder {
                    color: var(--logRegPlaceholderColor);
                }
                input:-ms-input-placeholder {
                    color: var(--logRegPlaceholderColor);
                }
                input:-moz-placeholder {
                    color: var(--logRegPlaceholderColor);
                    opacity: 1;
                }
                input::-moz-placeholder {
                    color: var(--logRegPlaceholderColor);
                    opacity: 1;
                }
                .eye-icon {
                    font-size: 18px;
                    color: var(--logRegEyeIconColor);
                }
            }
        }
    }
    .bottom-box {
        .register-btn-box {
            width: 100%;
            height: 45px;
            margin-top: 22px;
            background: var(--logRegBtnBgColor);
            line-height: 45px;
            text-align: center;
            font-weight: 600;
            color: var(--textColor1);
            letter-spacing: 0.5px;
            border-radius: 41px;
        }
        .login-box {
            margin-top: 16px;
            line-height: 25px;
            text-align: center;
            font-weight: 600;
            font-size: 14px;
            color: rgba(255, 255, 255, 0.7);
            a {
                color: var(--forgetTextColor);
            }
        }
    }
}
</style>
